<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" @submit.native.prevent>
                <el-form-item label="班级">
                    <el-select v-model="form.classId" filterable clearable placeholder="请选择">
                        <el-option
                            v-for="item in classList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div>
                  <el-link type="warning" @click="loadData"><i class="el-icon-refresh"></i>刷新数据,实时查看学生交卷状态</el-link>
                             &nbsp;&nbsp;&nbsp;&nbsp;
            </div>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="180"
                    prop="name"
                    label="班级名称">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="examTotalNumber"
                    label="报考人数">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="takeTheExamNumber"
                    label="参考人数">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="notTakeTheExamNumber"
                    label="未参考人数">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="submittedPaperNumber"
                    label="交卷人数">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="notSubmittedPaperNumber"
                    label="未交卷人数">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>
export default {
    components: {},
    props: [
        "attr"
    ],
    data() {
        return {
            form: {
                examId: this.attr.examId,
                classId: "",
            },
            tableData: [],
            classList: [],
        }
    },
    watch: {
        "form": {
            handler: function (newValue) {
                if (event.keyCode == 32 || event.keyCode == 13) return;
                this.loadData();
            },
            deep: true
        }
    },
    methods: {
        loadData() {
            let examId = this.form.examId;
            let classId = this.form.classId;
            this.$ajaxPost("/exam/peopleNumberStatistics/" + examId + "-" + classId, {}, (data) => {
                if (data && data.result && data.success) {
                    this.tableData = data.result;
                }
            })
        },
        initClassSelect() {
            this.$ajaxPost("/exam/getExamClassList/" + this.form.examId, {}, (data) => {
                if (data && data.result && data.success) {
                    this.classList = data.result;
                }
            })
        },
    },
    created() {
        this.initClassSelect();
        this.loadData();
    }
}
</script>
